<template>
    <div>
        <vs-table
            stripe
            border
            description
            :sst="true"
            :data="table.data"
            :max-items="table.length"
            :total="table.total"
            @search="handleSearch"
            @change-page="handleChangePage"
            @sort="handleSort">
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="flex items-center justify-between p-3 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                        <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of {{ this.table.total }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                            <span>{{ item }}</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>

                <div class="con-input-search vs-table--search">
                    <input
                        type="text"
                        class="input-search vs-table--search-input"
                        placeholder="Search here"
                        v-model="search"
                        @input="onChangeSearch(search)"
                        @keyup.enter="handleSearch(search)"
                    >
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>

                <vs-button
                    size="small"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-search"
                    title="Search"
                    style="margin-left: 5px"
                    @click="handleSearch(search)"
                ></vs-button>
            </template>

            <template slot="thead">
                <vs-th><vs-checkbox @click.stop="addAllChecked()" v-model="checkedAll"></vs-checkbox>Action </vs-th>
                <vs-th style="width: 25%;" sort-key="code">SR Data </vs-th>
                <vs-th sort-key="code">Supplier Data</vs-th>
                <vs-th sort-key="">Warehouse</vs-th>
                <vs-th v-if="status=='planning'" sort-key="">Return Date</vs-th>
                <vs-th v-if="status!='planning'" sort-key="">Handover Document</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div class="flex vx-input-group" v-if="status=='planning'">
                            <vs-button 
                                v-if="tr.warehouse_id > 0"
                                :disabled="!checkPermission('edit')"
                                size="small" 
                                color="#3e0" 
                                icon-pack="feather" 
                                icon="icon-edit" 
                                title="Edit"
                                style="margin-right: 5px" 
                                @click="handleEdit(tr.id, tr.return_id, tr.return_type)"
                            />
                            <vs-button 
                                v-if="tr.id > 0 || tr.warehouse_id == 0"
                                :disabled="!checkPermission('view')"
                                size="small" 
                                color="warning" 
                                icon-pack="feather" 
                                icon="icon-eye"
                                title="Detail"
                                style="margin-right: 5px"
                                @click="handleDetail(tr.id, tr.return_id, tr.return_type)"
                            />
                            <vs-button
                                size="small" v-if="tr.id > 0"
                                :disabled="!checkPermission('create')"
                                color="success"
                                icon-pack="feather"
                                icon="icon-package"
                                title="Handover"
                                style="margin-right: 5px"
                                @click="handleHandover(tr.id)"
                            />
                        </div>

                        <div class="flex vx-input-group" v-if="status=='handover'">
                            <vs-checkbox 
                                v-on:click="addChecked(indextr, tr.id)"
                                :checked="checked.includes(tr.id)"
                                color="primary"
                            ></vs-checkbox>

                            <div class="space-y-2 ml-2 w-full">
                                <div class="vx-row" style="margin-left: -4px; margin-right: -4px;">
                                    <div class="vx-col w-1/3" style="padding-left: 4px; padding-right: 4px;">
                                        <vs-button
                                            size="small"
                                            color="warning"
                                            icon-pack="feather"
                                            icon="icon-printer"
                                            title="Print"
                                            @click="handlePrint(tr.id)"
                                        />
                                    </div>
                                    <div class="vx-col w-1/3" style="padding-left: 4px; padding-right: 4px;">
                                        <vs-button
                                            size="small"
                                            color="warning"
                                            icon-pack="feather"
                                            icon="icon-printer"
                                            title="Print BAPP"
                                            @click="handlePrint(tr.id, 'bapp')"
                                        />
                                    </div>
                                    <div class="vx-col w-1/3" style="padding-left: 4px; padding-right: 4px;">
                                        <vs-button
                                            size="small"
                                            color="warning"
                                            icon-pack="feather"
                                            icon="icon-printer"
                                            title="Print BASTP"
                                            @click="handlePrint(tr.id, 'bastp')"
                                        />
                                    </div>
                                </div>
                                <div class="vx-row" style="margin-left: -4px; margin-right: -4px;">
                                    <div class="vx-col w-1/3" style="padding-left: 4px; padding-right: 4px;">
                                        <vs-button
                                            size="small"
                                            color="success"
                                            icon-pack="feather"
                                            icon="icon-box"
                                            title="Handover"
                                            @click="handleHandover(tr.id)"
                                        />
                                    </div>
                                    <div class="vx-col w-1/3" style="padding-left: 4px; padding-right: 4px;">
                                        <vs-button
                                            size="small"
                                            color="success"
                                            icon-pack="feather"
                                            icon="icon-check"
                                            title="Complete"
                                            @click="handleComplete(tr.id)"
                                        />
                                    </div>
                                    <div class="vx-col w-1/3" style="padding-left: 4px; padding-right: 4px;">
                                        <vs-button
                                            size="small"
                                            color="danger"
                                            icon-pack="feather"
                                            icon="icon-x"
                                            title="Cancel Handover"
                                            @click="handleCancel(tr.id)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex vx-input-group" v-if="status=='completed'">
                            <vs-button 
                                size="small"
                                color="warning"
                                icon-pack="feather"
                                icon="icon-eye"
                                title="Detail"
                                style="margin-right: 5px"
                                @click="handleDetail(tr.id, tr.return_id, tr.return_type)"
                                :disabled="!checkPermission('view')"
                            />
                            <vs-button
                                size="small"
                                color="#7d33ff"
                                icon-pack="feather"
                                icon="icon-printer"
                                title="Print"
                                style="margin-right: 5px"
                                @click="handlePrintComplete(tr.id, tr.return_id, tr.return_type)"
                                :disabled="!checkPermission('view')"
                            />
                            <vs-button
                                size="small"
                                color="danger"
                                icon-pack="feather"
                                icon="icon-rotate-ccw"
                                title="Reversal"
                                style="margin-right: 5px"
                                :disabled="(tr.doc_source === 'import - PO Return Begbal') ? true : false"
                                @click="handleReversal(tr.id)"
                            />
                        </div>

                        <div class="flex vx-input-group" v-if="status=='reversal'">
                            <vs-button 
                                v-if="tr.id > 0 || tr.warehouse_id == 0"
                                :disabled="!checkPermission('view')"
                                size="small" 
                                color="warning" 
                                icon-pack="feather" 
                                icon="icon-eye"
                                title="Detail"
                                style="margin-right: 5px"
                                @click="handleDetail(tr.id, tr.return_id, tr.return_type)"
                            />
                        </div>

                        <div class="flex vx-input-group" v-if="status=='reversed'">
                            <vs-button 
                                v-if="tr.id > 0 || tr.warehouse_id == 0"
                                :disabled="!checkPermission('view')"
                                size="small" 
                                color="warning" 
                                icon-pack="feather" 
                                icon="icon-eye"
                                title="Detail"
                                style="margin-right: 5px"
                                @click="handleDetail(tr.id, tr.return_id, tr.return_type)"
                            />
                        </div>

                        <div class="flex vx-input-group" v-if="status=='canceled'">
                            <vs-button 
                                size="small"
                                color="warning"
                                icon-pack="feather"
                                icon="icon-eye"
                                title="Detail"
                                style="margin-right: 5px"
                                @click="handleDetail(tr.id, tr.return_id, tr.return_type)"
                            />
                            <vs-button
                                size="small"
                                color="#7d33ff"
                                icon-pack="feather"
                                icon="icon-printer"
                                title="Print"
                                style="margin-right: 5px"
                                @click="handlePrintComplete(tr.id, tr.return_id, tr.return_type)"
                            />
                        </div>
                    </vs-td>
                    <vs-td>
                        <div class="flex flex-col content-center">
                            <div><b>SR Code :</b> {{ tr.return_code }}</div>
                            <div><b>GRR Code :</b> {{ tr.grr_code }}</div>
                            <div><b>SR Code External :</b> {{ tr.sr_ref ? tr.sr_ref : '' }}</div>
                            <div><b>GRR Code External :</b> {{ tr.ref_code_external ? tr.ref_code_external : '' }}</div>
                            <div><b>Type :</b> {{ Number(tr.return_type) == 0 ? 'With Reference' : 'Without Reference' }}</div>
                            <div v-if="tr.id > 0"><b>Status :</b> {{ tr.status }}</div>
                        </div>
                    </vs-td>
                    <vs-td key="supplier">
                        <div class="flex flex-col content-center">
                            <div>Code : {{ tr.supplier_code }}</div>
                            <div>Name : {{ tr.supplier_name }}</div>
                            <div>City : {{ tr.supplier_city }}</div>
                        </div>
                    </vs-td>
                    <vs-td key="warehouse_data">
                        <div class="flex flex-col content-center">
                            <div>Code : {{ tr.warehouse.code }}</div>
                            <div>Name : {{ tr.warehouse.name }}</div>
                            <div>City : {{ tr.warehouse.city }}</div>
                        </div>
                    </vs-td>
                    <vs-td v-if="status=='planning'">
                        <div class="flex flex-col content-center">
                            {{ tr.date ? (formatDate(tr.date)) : (formatDate(tr.return_date)) }}
                        </div>
                    </vs-td>
                    <vs-td v-if="status!='planning'" key="warehouse">
                        <div class="flex flex-col content-center">
                            <div>{{ tr.code ? tr.code: "---" }}</div>
                            <div>( {{ tr.doc_source }} )</div>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <div class="mb-6 space-x-1 flex">
            <vs-button
                v-on:click="submit()"
                color="primary"
                icon-pack="feather"
                icon="icon-inbox"
                v-if="status === 'handover'"
            >Submit</vs-button>
        </div>
        <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
    </div>
</template>

<script>
import moment from "moment";
export default {
    components: {},
    props: {
        draw: {
            type: Number,
        },
        srId: {
            type: Number,
        },
        warehouseId: {
            type: Number,
        },
        supplierId: {
            type: Number,
        },
        rangeDate: {
            default: null,
        },
        status: {
            type: String,
            default: "Draft",
        },
    },
    data() {
        return {
            deleteId: null,
            table: this.tableDefaultState(),
            checkedAll: false,
            checked: [],
            timeOuts: null,
            search: "",
            localDraw: 0,
        };
    },
    methods: {
        checkPermission(stat) {
            return this.$store.getters['user/hasPermissions'](stat);
        },
        toggleDisabled(condition, permission) {
            if (this.checkPermission(permission)) {
                if (condition) {
                    // expected condition?
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        handlePrint(id, printType) {
            const routeData = this.$router.resolve({
                name: `outbound.supplier-return.print${printType ? `-${printType}` : ""}`,
                params: { id: id },
            });
            window.open(routeData.href, "_blank");
        },
        tableDefaultState() {
            return {
                data: [],
                length: 10,
                page: 1,
                search: "",
                order: "created_at",
                sort: "desc",
                total: 0,
                totalPage: 1,
                totalSearch: 0,
                limits: [10, 25, 50, 100, "All"],
                start: 1,
                end: 0,
            };
        },
        onChangeSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            this.localDraw++
        },
        handleChangePage(page) {
            this.table.page = page;
            this.getData();
        },
        handleSort(key, active) {
            this.table.order = key;
            this.table.sort = active;
            this.getData();
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData();
        },
        getData() {
            var params = {
                limit: this.table.length,
                page: this.table.page,
                query: this.table.search,
                order: this.table.order,
                sort: this.table.sort,
                id: this.srId,
                warehouse_id: this.warehouseId,
                supplier_id: this.supplierId,
                status: this.status,
            }

            if (this.rangeDate) {
                params.start_date = this.rangeDate.startDate
                params.end_date = this.rangeDate.endDate
            }

            if (this.draw > 0 || this.localDraw > 0) {
                this.$vs.loading();
                this.$http.get(this.$store.state.outbound.supplierReturn.baseUrlPath, {
                    params: params,
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.checkedAll = false;
                        this.checked = [];

                        this.table.total = resp.data.total_rows;
                        this.table.totalPage = resp.data.total_pages;
                        this.table.totalSearch = resp.data.total_record_search;
                        this.table.length = resp.data.limit;
                        this.table.data = resp.data.rows;
                        this.setStartEnd();
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                        this.$vs.dialog({
                            color: "danger",
                            title: "Something went wrong",
                            text: resp.message,
                        });
                    }
                })
                .catch(error => {
                    this.$vs.loading.close();
                    console.log(error);
                    this.$vs.dialog({
                        color: "danger",
                        title: "Something went wrong",
                        text: error,
                    });
                });
            }
        },
        setStartEnd() {
            let valStart =this.table.length * this.table.page - this.table.length + 1;
            if (valStart > this.table.total) {
                valStart = 1;
            }

            if (this.table.total == 0) {
                valStart = 0;
            }

            let valEnd = this.table.length * this.table.page;
            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }

            if (this.table.totalSearch < this.table.total && this.table.search != "") {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        handleEdit(id, return_id, type) {
            this.$router.push({
                name: this.$store.state.outbound.supplierReturn.baseRouterName + ".form",
                params: { id: id },
                query: {
                    t: type,
                    r: return_id
                },
            });
        },
        handleReversal(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "success",
                title: `Confirm`,
                text: "Are you sure to put it to reversal process?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.patch(`${this.$store.state.outbound.supplierReturn.baseUrlPath}/${id}/reversal`)
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: "The data was requested for reversal",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.notify({
                                color: "danger",
                                title: "Error",
                                text: resp.message,
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        }

                        this.$vs.loading.close();
                        this.getData();
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                    });
                },
            });
        },
        handleDetail(id, return_id, type) {
            this.$router.push({
                name: this.$store.state.outbound.supplierReturn.baseRouterName + ".detail",
                params: { id: id, tabSource: "outbound" },
                query: {
                    t: type,
                    r: return_id
                },
            });
        },
        handlePrintComplete(id, return_id, type) {
            const routeData = this.$router.resolve({
                name: "supplier-return.print-complete",
                params: { id: id },
                query: {
                    t: type,
                    r: return_id
                },
            });
            window.open(routeData.href, "_blank");
        },
        handleHandover(id) {
            if (this.status == "planning") {
                this.$vs.dialog({
                    type: "confirm",
                    color: "success",
                    title: `Confirm`,
                    text: "Are you sure to handing over this data?",
                    accept: () => {
                        this.$vs.loading();
                        this.$http.patch(`${this.$store.state.outbound.supplierReturn.baseUrlPath}/${id}/handover`)
                        .then((resp) => {
                            if (resp.code == 200) {
                                this.$vs.notify({
                                    color: "success",
                                    title: "Success",
                                    text: "The data was marked as handed over",
                                    position: "top-right",
                                    iconPack: "feather",
                                    icon: "icon-x-circle",
                                });
                            } else {
                                this.$vs.notify({
                                    color: "danger",
                                    title: "Error",
                                    text: resp.message,
                                    position: "top-right",
                                    iconPack: "feather",
                                    icon: "icon-x-circle",
                                });
                            }

                            this.$vs.loading.close();
                            this.getData();
                        })
                        .catch((error) => {
                            this.$vs.loading.close();
                            console.log(error);
                        });
                    },
                });
            } else if (this.status == "handover") {
                this.$router.push({
                    name: this.$store.state.outbound.supplierReturn.baseRouterName + ".handover-edit",
                    params: { id: id },
                });
            }
        },
        handleComplete(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "success",
                title: `Confirm`,
                text: "Are you sure to complete this data?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.patch(`${this.$store.state.outbound.supplierReturn.baseUrlPath}/${id}/completed`)
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.dialog({
                                color: "success",
                                title: "Success",
                                text: resp.message,
                            });
                        } else {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Error",
                                text: resp.message,
                            });
                        }

                        this.$vs.loading.close();
                        this.getData();
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                    });
                },
            });
        },
        handleCancel(id) {
            this.$vs.dialog({
                type: "confirm",
                color: "success",
                title: `Confirm`,
                text: "Are you sure to cancel this handover?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post(`${this.$store.state.outbound.supplierReturn.baseUrlPath}/${id}/cancel`)
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.dialog({
                                color: "success",
                                title: "Success",
                                text: resp.message,
                            });
                        } else {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Error",
                                text: resp.message,
                            });
                        }

                        this.$vs.loading.close();
                        this.getData();
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                    });
                },
            });
        },
        utcToLocal(val) {
            if (val) {
                return moment(val)
                    .add(-7, "h")
                    .utc()
                    .local()
                    .format("DD MMM YYYY HH:mm:ss");
            }
        },
        addChecked(index, val) {
            if (this.checked.includes(val)) {
                this.checked.splice(this.checked.indexOf(val), 1);
            } else {
                this.checked.push(val);
            }
        },
        addAllChecked() {
            if (this.checkedAll == false) {
                for (var i = 0; i < this.table.data.length; i++) {
                    if (this.table.data[i].id > 0) {
                        if (this.checked.includes(this.table.data[i].id)) {
                            //
                        } else {
                            this.checked.push(this.table.data[i].id);
                        }
                    }
                }
            } else {
                for (var j = 0; j < this.table.data.length; j++) {
                    this.checked.splice(this.checked.indexOf(this.table.data[j].id), 1);
                }
            }
        },
        submit() {
            if (this.checked.length > 0) {
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: `Confirm`,
                    text: "Are you sure to complete these data(s)?",
                    accept: () => {
                        let param = {
                            sr_id: this.checked
                        }

                        this.$vs.loading();
                        this.$http.patch(`${this.$store.state.outbound.supplierReturn.baseUrlPath}/0/completed`, param)
                        .then((resp) => {
                            if (resp.code == 200) {
                                this.$vs.notify({
                                    color: "success",
                                    title: "Success",
                                    text: "The data was marked as completed",
                                    position: "top-right",
                                    iconPack: "feather",
                                    icon: "icon-x-circle",
                                });
                            } else {
                                this.$vs.notify({
                                    color: "danger",
                                    title: "Error",
                                    text: resp.message,
                                    position: "top-right",
                                    iconPack: "feather",
                                    icon: "icon-x-circle",
                                });
                            }

                            this.$vs.loading.close();
                            this.getData();
                        })
                        .catch((error) => {
                            this.$vs.loading.close();
                            console.log(error);
                        });
                    }
                })
            } else {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "At least 1 checkbox required",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                });
            }
        },
    },
    mounted() {
        // ...
    },
    watch: {
        draw() {
            this.getData();
        },
        localDraw() {
            this.getData();
        },
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
        formatDate: () => {
            return (val) => moment.utc(val).format("YYYY-MM-DD")
        },
        formatLocalNumber: () => {
            return (val) => {
                return Number(val).toLocaleString("id-ID");
            };
        },
    },
};
</script>
  